<!-- <app-admin-header></app-admin-header>

<div style="border: 1px solid #fff; margin: 80px 150px; border-color: #fff !important; background-color: #fff; font-family: 'Times New Roman', Times, serif;">

    <div *ngIf="isLoading"  class="d-flex text-center justify-content-center mt-3">
        <p class="text-muted">Loading... Please wait</p>
      </div>

      <div *ngIf="isEmpty"  class="d-flex text-center justify-content-center mt-3">
        <p class="text-muted">Error loading Demand Notice</p>
      </div>
    
    <div *ngIf="!isEmpty && !isLoading" style="padding: 30px 40px;">
        
        <div style="position: absolute; margin: 30% 10%; text-align: center; align-self: center; width: 50%; height: 50%; opacity: 0.03;">
            <img src="assets/img/AIRS-Logo.png" alt="logo" style="width: 100%; height: 100%;">
        </div>

        <div style="display: flex; flex-direction: row; justify-content: center; align-items: center;">
            <div style="margin-right: 15px">
                <img src="assets/img/Anambra-Logo.png" alt="logo" style="width: 100px; height: 100px;">
            </div>
            <div style="display: flex; flex-direction: column; align-items: center;">
                <h6 style="font-size: 24px; text-transform: uppercase; font-weight: bold;">Anambra State</h6>
                <h6 style="font-size: 18px; text-transform: uppercase; font-weight: bold; color: #795B18;">Internal Revenue Central System</h6>
            </div>
            <div style="margin-left: 0px">
                <img src="assets/img/AIRS-Logo.png" alt="logo" style="width: 170px; height: 110px;">
            </div>
        </div>

        <div style="display: flex; flex-direction: row; justify-content: center; align-items: center;">
            <h5 style="font-size: 15px; text-transform: uppercase; font-weight: bold;">{{details?.assessmentType | removeUnderscores}}</h5>
        </div> 

        <div style="display: flex; flex-direction: row; justify-content: center; align-items: center; margin-bottom: 30px;;">
            <h5 style="font-size: 22px; text-transform: uppercase; font-weight: bold;">Notice of Assessment</h5>
        </div> 

        <div style="display: flex; flex-direction: row; margin: 10px 0px;">
            <div style="width: 45%;">
                <div style="display: flex; flex-direction: row;">
                    <h6 style="font-size: 13px;; text-transform: uppercase;">YEAR OF ASSESSMENT:</h6>
                    <h6 style="margin-left: 30px; font-size: 13px;; font-weight: bold;">{{details?.filingYear}}</h6>
                </div>
                <div style="border: 2px dashed black; background: #FFFDF9; width: 100%; height: 170px; display: flex; flex-direction: row; padding: 20px 30px;">

                    <div style="width: 30%; display: block;">
                        <img src="{{details?.photo}}" alt="user photo" style="width: 100px; height: 100px;">                    
                    </div>

                    <div style="width: 70%; display: flex; flex-direction: column;">

                        <div style="display: flex; flex-direction: row; margin-bottom: 5px;">
                            <h6 style="width: 100%; font-size: 13px;; text-transform: uppercase;">
                                {{details?.displayName | uppercase}}
                            </h6>
                        </div>
                        <div style="display: flex; flex-direction: row; margin-bottom: 5px;">
                            <h6 style="width: 100%; font-size: 13px;; text-transform: uppercase;">
                                {{details?.address | uppercase}}
                            </h6>
                        </div>

                        <div style="display: flex; flex-direction: row; margin-bottom: 5px;">
                            <h6 style="width: 100%; font-size: 13px;; text-transform: uppercase;">
                                {{details?.phoneNumber }}
                            </h6>
                        </div>

                        <div style="display: flex; flex-direction: row; margin-bottom: 5px;">
                            <h6 style="width: 100%; font-size: 13px;; text-transform: lowercase;">
                                {{details?.email}}
                            </h6>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div style="width: 10%;"></div>
            <div style="width: 45%;">
                <div style="display: flex; flex-direction: row; justify-content: end;">
                    <h6 style="font-size: 13px;; text-transform: uppercase;">AIRMS ID:</h6>
                    <h6 style="margin-left: 30px; font-size: 13px;; font-weight: bold; text-transform: uppercase;">{{assessmentId}}</h6>
                </div>
                <div style="border: 2px solid black; width: 100%; height: 170px; display: flex; flex-direction: row; padding: 20px 30px;">
                    <div style="width: 100%; display: flex; flex-direction: column;">
                       
                        <div style="display: flex; flex-direction: row; margin-bottom: 5px;">
                            <h6 style="font-size: 13px;; text-transform: uppercase;">ASIN:</h6>
                            <h6 style="margin-left: 30px; font-size: 13px;; text-transform: uppercase; font-weight: bold;">{{details?.asin}}</h6>
                        </div>
                        
                        <div style="display: flex; flex-direction: row; margin-bottom: 5px;">
                            <h6 style="font-size: 13px;; text-transform: uppercase;">Payment Status:</h6>
                            <h6 style="margin-left: 30px; font-size: 13px;; text-transform: uppercase; font-weight: bold;">{{details?.paymentStatus == 'NOT_PAID' ? 'Not Paid' : 'Paid'}}</h6>
                        </div>
                        <div style="display: flex; flex-direction: row; margin-bottom: 5px;">
                            <h6 style="font-size: 13px;; text-transform: uppercase;">Approval Status:</h6>
                            <h6 style="margin-left: 30px; font-size: 13px;; text-transform: uppercase; font-weight: bold;">{{details?.approvalStatus}}</h6>
                        </div>
                        <div *ngIf="details?.reason" style="display: flex; flex-direction: row; margin-bottom: 5px;">
                            <h6 style="font-size: 13px;; text-transform: uppercase;">Reason:</h6>
                            <h6 style="margin-left: 30px; font-size: 13px;; text-transform: uppercase; font-weight: bold;">{{details?.reason}}</h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div style="display: flex; flex-direction: column; margin-top: 30px;">
            <p style="font-size: 13px;">
                Pursuant to section 56 of the Personal Income Tax Act Cap P.8 LFN 2011 as amended, 
                notice is hereby given to you that an assessment of income tax has been made to you, 
                as detailed below, and that the undermentioned tax is payable on or before: 
                <span style="font-weight: bold;">31/12/{{expiryYear}}</span>       
            </p>
            <p style="font-size: 13px; margin-top: 10px;">
                If you dispute this assessment, you may give notice of objection in 
                writing or electronically to the relevant tax authority to 2020 revise this assessment, 
                within time under section 57 of Personal Income Tax Act Cap P.8 LFN 2011 as amended on 
                payment of half the tax assessed
            </p>
        </div>

        <div style="margin: 30px 0px;">
            <table style="border-collapse: collapse; width: 100%; font-size: 13px;">
                <thead style="background-color: #f2f2f2; font-size: 13px;">
                <tr style="font-size: 13px;">
                   
                    <th style="text-align: left; padding: 5px 20px; border: 1px solid #ddd; text-transform: uppercase; width: 50%">
                        ASSESSMENT INFORMATION
                    </th>
                    <th style="text-align: left; padding: 5px 20px; border: 1px solid #ddd; text-transform: uppercase; width: 50%">
                       
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    
                    <td style="text-align: left; padding: 5px 20px; border: 1px solid #ddd;">
                        <div style="width: 100%; display: flex; flex-direction: column;">
                            
                            <div style="display: flex; flex-direction: row; margin-bottom: 10px; margin-top: 5px;">
                                <h6 style="text-transform: uppercase; font-size: 13px;">Category:</h6>
                                <h6 style="margin-left: 30px; text-transform: uppercase; font-weight: bold; font-size: 13px;">{{details?.category | removeUnderscores}}</h6>
                            </div>
                            <div *ngIf="details?.subCategory && details?.subCategory != '--'" style="display: flex; flex-direction: row; margin-bottom: 10px;">
                                <h6 style="text-transform: uppercase; font-size: 13px;">Sub-Category:</h6>
                                <h6 style="margin-left: 30px; text-transform: uppercase; font-weight: bold; font-size: 13px;">{{details?.subCategory | removeUnderscores}}</h6>
                            </div>
                            
                           
                        </div>                
                    </td>

                    <td style="text-align: left; padding: 5px 20px; border: 1px solid #ddd;">
                        <div style="width: 100%; display: flex; flex-direction: column;">
                            <div style="display: flex; flex-direction: row; margin-bottom: 10px; margin-top: 5px;">
                                <h6 style="text-transform: uppercase; font-size: 13px;">Date Created:</h6>
                                <h6 style="margin-left: 30px; text-transform: uppercase; font-weight: bold; font-size: 13px;">{{details?.filingDate | date}}</h6>
                            </div>
                            <div style="display: flex; flex-direction: row; margin-bottom: 10px;">
                                <h6 style="text-transform: uppercase; font-size: 13px;">Created By:</h6>
                                <h6 style="margin-left: 30px; text-transform: uppercase; font-weight: bold; font-size: 13px;">{{details?.assessedBy}}</h6>
                            </div>
                           
                            
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <table style="border-collapse: collapse; width: 100%">
                <tbody>
                  
                    <tr>
                    <td style="text-align: left; padding: 5px 20px; border: 1px solid #ddd; width: 70%;">
                        <div style="width: 100%; display: flex; flex-direction: column;">
                            <h6 style="width: 100%; text-transform: uppercase; font-size: 13px;">TAX DUE:</h6>
                        </div>
                    </td>
                    <td style="text-align: left; padding: 5px 20px; border: 1px solid #ddd; width: 30%">
                        <div style="width: 100%; display: flex; flex-direction: column;">
                            <h6 style="margin-left: 30px; text-transform: uppercase; font-weight: bold; font-size: 13px;">{{details?.amount - 550 | nairaCurrency}}</h6>
                        </div>                
                    </td>
                    </tr>
                    <tr>
                    <td style="text-align: left; padding: 5px 20px; border: 1px solid #ddd; width: 70%;">
                        <div style="width: 100%; display: flex; flex-direction: column;">
                            <h6 style="width: 100%; text-transform: uppercase; font-size: 13px;">DEVELOPMENT LEVY PAYABLE:</h6>
                        </div>
                    </td>
                    <td style="text-align: left; padding: 5px 20px; border: 1px solid #ddd; width: 30%">
                        <div style="width: 100%; display: flex; flex-direction: column;">
                            <h6 style="margin-left: 30px; text-transform: uppercase; font-weight: bold; font-size: 13px;">{{500 | nairaCurrency}}</h6>
                        </div>                
                    </td>
                    </tr>
                    <tr>
                    <td style="text-align: left; padding: 5px 20px; border: 1px solid #ddd; width: 70%;">
                        <div style="width: 100%; display: flex; flex-direction: column;">
                            <h6 style="width: 100%; text-transform: uppercase; font-size: 13px;">Stamp duty Payable</h6>
                        </div>
                    </td>
                    <td style="text-align: left; padding: 5px 20px; border: 1px solid #ddd; width: 30%">
                        <div style="width: 100%; display: flex; flex-direction: column;">
                            <h6 style="margin-left: 30px; text-transform: uppercase; font-weight: bold; font-size: 13px;">{{50 | nairaCurrency}}</h6>
                        </div>                
                    </td>
                    </tr>
                    <tr style="height: 60px;">
                    <td style="text-align: left; padding: 5px 20px; border: 1px solid #ddd; width: 70%;">
                        <div style="width: 100%; display: flex; flex-direction: column;">
                            <h6 style="width: 100%; text-transform: uppercase; font-weight: bold; font-size: 13px;">TOTAL TAX DUE:</h6>
                        </div>
                    </td>
                    <td style="text-align: left; padding: 5px 20px; border: 1px solid #ddd; width: 30%">
                        <div style="width: 100%; display: flex; flex-direction: column;">
                            <h6 style="margin-left: 30px; text-transform: uppercase; font-weight: bold; font-size: 13px;">{{details?.amount | nairaCurrency}}</h6>
                        </div>                
                    </td>
                    </tr>
                </tbody>
            </table>    
        </div>

        <div style="display: flex; flex-direction: column; margin-top: 40px; margin-bottom: 50px;">
            <h4 style="font-size: 20px; text-transform: uppercase; font-weight: bold;">NOTICE:</h4>
            
           
            <div style="display: flex; flex-direction: row; margin-top: 20px;">
                <div style="width: 5%; margin-left: 20px;">
                    <h6 style="font-size: 13px; font-weight: bold;">1.</h6>
                </div>
                <div style="width: 95%;">
                    <h6 style="font-size: 13px;">
                        If you do not pay the tax due within the time allowed, the tax authority may 
                        enforce payment of the tax due by distress or sale of your goods and chattels 
                        or by civil proceedings or by criminal prosecution or by any combination of 
                        these methods.
                    </h6>
                </div>
            </div>  

            <div style="display: flex; flex-direction: row; margin-top: 20px;">
                <div style="width: 5%; margin-left: 20px;">
                    <h6 style="font-size: 13px; font-weight: bold;">2.</h6>
                </div>
                <div style="width: 95%;">
                    <h6 style="font-size: 13px;">
                        If you do not pay the tax due within the time allowed, the tax authority may 
                        enforce payment of the tax due by distress or sale of your goods and chattels 
                        or by civil proceedings or by criminal prosecution or by any combination of 
                        these methods.
                    </h6>
                </div>
            </div>

        </div>

       

        <div style="display: flex; flex-direction: row; justify-content: space-between; margin-left: 20px; margin-right: 20px; margin-bottom: 50px; ">

           <div style="display: flex; flex-direction: row; justify-content: space-between; margin-bottom: 50px;">
            <div *ngIf="details?.approvalStatus == 'APPROVED'"  class="action-buttons">
                <button  type="button" class="btn query-button" (click)="downloadNotice()"  >Download Demand Notice</button>
                <button *ngIf="details?.paymentStatus != 'PAID'"  type="button" class="btn approve-button" (click)="testReport()">Make Payment</button>
            </div>
           </div>
            
        </div>
    </div>

    
</div>

<div   style="display: flex; flex-direction: row; justify-content: space-between; margin-left: 200px; margin-bottom: 50px;">
    <div class="action-buttons">
        <button type="button" class="btn back-button" (click)="goBack()" >Back</button>
        
    </div>
   </div>

<app-footer></app-footer> -->

<div>
    <div class="head-section">
        <h6 class="header-text text-white">Assessments for {{details?.assessed | titlecase}}</h6>
        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="close()">
            <g clip-path="url(#clip0_3558_32756)">
                <path d="M1.96338 16.9345L9.47846 9.41938M16.9935 1.9043L9.47703 9.41938M9.47703 9.41938L1.96338 1.9043M9.47846 9.41938L16.9935 16.9345" stroke="#F00000" stroke-width="2.16781" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
                <clipPath id="clip0_3558_32756">
                    <rect width="17.3425" height="17.3425" fill="white" transform="translate(0.806641 0.748047)"/>
                </clipPath>
            </defs>
        </svg>
    </div>
    <div class="body-section">
        <div class="row justify-content-center mb-4">
            <div class="col-md-4">
                <img *ngIf="!details?.photo" src="assets/ass-user.svg" style="width: 130px;border-radius: 5px" alt="user" />
                <img *ngIf="details?.photo" src="{{details?.photo}}" style="width: 110px;border-radius: 5px" alt="user" />
            </div>
            <div class="col-md-8">
               
                <div class="w-100">
                    <table class="table table-striped table-hover table-bordered">
                        <tr>
                            <th class="data-th">ASIN NUMBER:</th>
                            <td class="data-td">{{ details?.asin }}</td>
                        </tr>
                        <tr>
                            <th class="data-th">PHONE NUMBER:</th>
                            <td class="data-td">{{ details?.phoneNumber }}</td>
                        </tr>
                        <tr>
                            <th class="data-th">NAME:</th>
                            <td class="data-td">{{details?.assessed}}</td>
                        </tr>
                        <tr>
                            <th class="data-th">EMAIL:</th>
                            <td class="data-td">{{ details?.email }}</td>
                        </tr>
                        <tr>
                            <th class="data-th">ADDRESS:</th>
                            <td class="data-td">{{ details?.address | titlecase }}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>

        <div style="position: relative;border: 1px solid #ccc;border-radius: 10px; background: #fff">
            <b style="position: absolute;background: #fff;padding: 0 10px;top: -12px;left: 20px">Assessment Details</b>

            <div class="row p-5">
                <div class="col-md-6">
                    <div class="input-bundled">
                        <label>Assessment Type</label>
                        <select>
                            <option>{{details?.assessmentType | removeUnderscores}}</option>
                        </select>
                    </div>
                    <div class="input-bundled mt-4">
                        <label>Sub-Category</label>
                        <select>
                            <option [value]="details?.subCategory">{{details?.subCategory | titlecase}}</option>
                        </select>
                    </div>
                    <div class="input-bundled mt-4">
                        <label>Created By:</label>
                        <select>
                            <option [value]="details?.assessedBy">{{details?.assessedBy | titlecase }}</option>
                        </select>
                       
                    </div> 
                </div>
                <div class="col-md-6">
                    <div class="input-bundled">
                        <label>Category</label>
                        <select>
                            <option [value]="details?.category">{{details?.category | titlecase }}</option>
                        </select>
                       
                    </div>
                    <div class="input-bundled mt-4">
                        <label>Date Created:</label>
                        <select>
                            <option [value]="details?.filingDate">{{details?.filingDate | datetime}}</option>
                        </select>
                    </div>

                    <div class="input-bundled mt-4" *ngIf="details?.reason">
                        <label>Query Reason:</label>
                        <select>
                            <option [value]="details?.reason">{{details?.reason}}</option>
                        </select>
                    </div>
                </div>

               
            </div>
        </div>

        <div class="mt-4 mb-5">
            <table class="table table-bordered table-striped mb-0">

                <!-- PRESUMPTIVE_TAX -->
                <tr>
                    <th class="th" style="border-radius: 5px 0 0 0;border: none">YEAR</th>
                    <th *ngIf="details?.regType" class="th">TYPE</th>
                    <th *ngIf="details?.assessmentType == 'PRESUMPTIVE_TAX'" class="th">TAX PAYABLE</th>
                    <th *ngIf="details?.assessmentType == 'PRESUMPTIVE_TAX'" class="th">STD</th>
                    <th *ngIf="details?.assessmentType == 'PRESUMPTIVE_TAX'" class="th">DEV. LEVY</th>
                    <th *ngIf="details?.assessmentType == 'PRESUMPTIVE_TAX'" class="th" style="border-radius: 0 5px 0 0;border: none">LINE TOTAL</th>
                    <th *ngIf="details?.assessmentType != 'PRESUMPTIVE_TAX'" class="th" style="border-radius: 0 5px 0 0;border: none">Amount</th>
                </tr>
                <tr *ngIf="details">
                    <td class="td" style="border: 1px solid #ddd;border-bottom-left-radius: 5px;">{{ details?.filingYear }}</td>
                    <td *ngIf="details?.regType" class="td">{{details?.regType}}</td>
                    <td *ngIf="details?.assessmentType == 'PRESUMPTIVE_TAX'" class="td">{{ details?.amount - 550 | nairaCurrency }}</td>
                    <td *ngIf="details?.assessmentType == 'PRESUMPTIVE_TAX'" class="td">{{ 50 | nairaCurrency }}</td>
                    <td *ngIf="details?.assessmentType == 'PRESUMPTIVE_TAX'" class="td">{{ 500 | nairaCurrency}}</td>
                    <td class="td">{{ details?.amount | nairaCurrency }}</td>
                </tr>
            </table>
    <br>
            <div class="row">
                <div class="col-md-5">
                    <div class="input-bundled mt-4">
                        <label *ngIf="details?.assessmentType == 'PRESUMPTIVE_TAX'">Total Tax Payable</label>
                        <label *ngIf="details?.assessmentType != 'PRESUMPTIVE_TAX'">Amount</label>
                        <div class="d-flex flex-row">
                            <span class="naira-span">₦</span>
                            <input class="naira-input"  [value]="details?.amount | nairaCurrency" />
                        </div>
                    </div>
                </div>
            </div>

            <p class="text-danger mt-3" style="text-align: center; font-size: 13px" *ngIf="details?.approvalStatus == 'QUERIED'">
                <span style="color: #1a1a1a">Reason for query:</span> {{details?.reason}}<br>
                <button  type="button" class="btn  btn-warning" (click)="openEdit()">Edit</button>
            </p>
        </div>

        <div class="modal-footer">
            <div class="action-buttons" *ngIf="details?.approvalStatus =='APPROVED' ">
                <button  type="button" class="btn submit-button" (click)="downloadNotice()">
                    <b *ngIf="!isDownloading">Download Demand Notice</b>
                    <b *ngIf="isDownloading"  class="spinner-border text-dark"></b>
                </button>
                <button  *ngIf="details?.paymentStatus =='NOT_PAID' && details?.approvalStatus =='APPROVED' " type="button" class="btn submit-button2" (click)="payOnline()">Pay Online</button>
            </div>

            <div class="action-buttons" *ngIf="details?.approvalStatus =='PENDING'">
                <button  type="button" class="btn  preview-button" >Pending Approval</button>
            </div>
        </div>
        <div *ngIf="details">
            <app-user-comment-global [assessmentId]="details?.assessmentId"></app-user-comment-global>
        </div>
    </div>
</div>
